<template>
    <form>
      <div class="form-row">
        <div class="form-item form-item-50" :class="{ hasError: showErrors && !address.street }">
            <label>{{ $t('form.address.fld_street') }} *</label>
            <input name="address.street"
       type="text"
       v-model="address.street"
       v-on:blur="tryGeocode()"
       required
       />
          </div>
          <div class="form-item form-item-25" :class="{ hasError: showErrors && !address.streetnumber }">
            <label>{{ $t('form.address.fld_streetnumber') }} *</label>
            <input name="address.streetnumber" type="text" v-model="address.streetnumber" required v-on:blur="tryGeocode()"/>
          </div>
          <div class="form-item form-item-25">
            <label>{{ $t('form.address.fld_co_line') }}</label>
            <input name="address.co_line" type="text" v-model="address.co_line" v-on:blur="tryGeocode()"/>
          </div>
        </div>
        <div class="form-row">
          <div class="form-item form-item-20" :class="{ hasError: showErrors && !address.zip }">
            <label>{{ $t('form.address.fld_zip') }} *</label>
            <input name="address.zip" type="text" v-model="address.zip" v-on:blur="tryGeocode()"/>
          </div>
          <div class="form-item form-item-40" :class="{ hasError: showErrors && !address.locality }">
            <label>{{ $t('form.address.fld_locality') }} *</label>
            <input name="address.locality" type="text" v-model="address.locality" v-on:blur="tryGeocode()"/>
          </div>
          <div class="form-item form-item-40" :class="{ hasError: showErrors && !address.country }">
            <label>{{ $t('form.address.fld_country') }} *</label>
            <select name="address.country" v-model="address.country" v-on:blur="tryGeocode()">
              <option disabled value='null'>{{ $t('form.address.fld_country_null') }}*</option>
              <option value="DE">{{ $t('form.address.fld_country_de') }}</option>
              <option value="CH">{{ $t('form.address.fld_country_ch') }}</option>
              <option value="AT">{{ $t('form.address.fld_country_at') }}</option>
              <option value="OTHER">{{ $t('form.address.fld_country_other') }}</option>
            </select>
          </div>
        </div>

        <div v-if="geocodingInProgress" class="alert alert-notice">
          <img src="static/letsfamily-de/img/spinner.svg" width="20" height="20"/>
          {{ $t('form.address.address_is_being_checked') }}
        </div>
        <div v-else>
          <div v-if="hasData && !geocodeResult && !address.lat && !address.long" class="alert alert-error">
            {{ $t('form.address.address_not_valid') }}
          </div>

          <div v-if="showHint && geocodeResult == 'success' && exactHit" class="alert alert-success">
            <h4>{{ $t('form.address.address_is_valid') }}</h4>
            <p><b>{{ address.formatted_address }}</b></p>
            <button class="btn-ok" v-on:click.prevent="addressOK()" >{{ $t('form.address.btn_address_ok') }}</button>
            <br/><br/>
            <h4>{{ $t('form.address.address_is_valid_reject_title') }}</h4>
            <p>{{ $t('form.address.address_is_valid_reject_text') }} <b>{{ niceAddress(manualAddress) }}</b></p>
            <button class="btn-ok" v-on:click.prevent="chooseUserData()" >{{ $t('form.address.btn_use_my_address') }}</button>
          </div>
          <div v-else-if="showHint && geocodeResult == 'success' && !exactHit" class="alert alert-notice">
            <h4>{{ $t('form.address.address_fuzzy_hit') }}</h4>
            <p>{{ $t('form.address.address_fuzzy_hit_suggestion') }} <b>{{ this.address.formatted_address }}</b></p>
            <button class="btn-notice" v-on:click.prevent="chooseSuggestion()" >{{ $t('form.address.btn_use_suggestion') }}</button>
            <br/><br>
            <h4>{{ $t('form.address.address_fuzzy_hit_reject_title') }}</h4>
            <p>{{ $t('form.address.address_fuzzy_hit_reject_text') }} <b>{{ niceAddress(manualAddress) }}</b></p>
            <button class="btn-notice" v-on:click.prevent="chooseUserData()" >{{ $t('form.address.btn_use_my_address') }}</button>
                     </div>
          <div v-else-if="showHint && geocodeResult == 'error'" class="alert alert-error">
            <h4>{{ $t('form.address.address_not_valid') }}</h4>
            <p>{{ $t('form.address.address_not_valid_hint') }}</p>
            <button class="btn-error" v-on:click.prevent="chooseUserData()" >{{ $t('form.address.btn_use_invalid_address') }}</button>
          </div>
        </div>
        <div v-if="!google" class="alert alert-notice">
          {{ $t('form.address.google_api_null') }}
        </div>
      </form>
</template>

<script>
import { mapGetters } from "vuex";
import mapsInit from "@/api/maps.js";
import {
  extractAddrObj
 } from "@/api/Georequest.js";

export default {
  name: 'AddressForm',
  props: {
    apiKey: String,
    address: Object,
    showErrors: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hasData: this.calcHasData(),
      googleApiKey: this.$parent.googleApiKey,
      google: null,
      googleGeocoder: null,
      geocodeResult: null,
      loadedAddress: null,
      exactHit: false,
      geocodingInProgress: false,
      fuzzyAddress: {},
      manualAddress: {},
      showHint: false,
    };
  },
  computed: {
    ...mapGetters({
      axiosBusy: "axiosIsBusy",
    }),
  },
  async mounted() {
    try {
      this.google = await mapsInit(this.googleApiKey);
      this.googleGeocoder = new this.google.maps.Geocoder();
    } catch (error) {
      throw new Error(error);
    }
    this.loadedAddress = this.addressAsString(this.address);
    this.manualAddress = this.address;
  },
  methods: {
    calcHasData() {
      return this.allValid();
    },
    allValid: function() {
      if ( this.address.country &&
        this.address.locality &&
        this.address.street.length >= 3 &&
        this.address.streetnumber &&
        this.address.zip && this.address.zip.length >= 3
      ) {
          return true;
      } else {
          return false;
      }
    },
    addressOK() {
      this.showHint = false;
    },
    async chooseUserData() {
      this.address.formatted_address = this.niceAddress(this.manualAddress);
      this.address.quality='manual-user';
      this.address.street = this.manualAddress.street;
      this.address.streetnumber = this.manualAddress.streetnumber;
      this.address.country = this.manualAddress.country;
      this.address.locality = this.manualAddress.locality;
      this.address.zip = this.manualAddress.zip;
      async function geoZIP(args, geocoder) {
        const geoPromise = new Promise((resolve, reject) => {
          geocoder.geocode(
            {
              address: args.zip + ' ' + args.locality ,
              componentRestrictions: {
                country: args.country,
              }
            },
            (results, status) => {
              if (status !== "OK" || !results[0]) {
                reject(status);
              }
              resolve(results);
            }
          );
        });
        let rv = geoPromise
            .then(results => {
              for (var i = 0; i < results.length; i++) {
                let currentResult = results[i];
                if (currentResult.geometry.location_type == "APPROXIMATE") {
                  return { status: "hit", location: extractAddrObj(currentResult)};
                }
              }
              return { status: "miss" };
            })
            .catch(reason => {
              if (reason === "ZERO_RESULTS") {
                return {
                  status: "ERROR",
                  description: "Location not Found",
                  flag: "NO_LOC"
                };
              } else {
                throw new Error(reason);
              }
            });
        return rv;
      }
      let zip = await geoZIP(this.address, this.googleGeocoder);
      if (zip.status === 'hit') {
        this.address.lat = zip.location.latitude;
        this.address.long = zip.location.longitude;
      }
      this.showHint = false;
      this.$emit('address-geocode', { address: this.address, status: 'success', hit: false });
    },
    chooseSuggestion(){
      this.address.quality='fuzzy';
      this.address.street = this.fuzzyAddress.streetName;
      this.address.streetnumber = this.fuzzyAddress.streetNumber ? this.fuzzyAddress.streetNumber : this.address.streetnumber;
      this.address.country = this.fuzzyAddress.countryCode;
      this.address.locality = this.fuzzyAddress.city;
      this.address.zip = this.fuzzyAddress.zipcode;
      this.showHint = false;
      this.$emit('address-geocode', { address: this.address, status: 'success', hit: false });
    },
    async tryGeocode() {
      if (this.allValid() && this.loadedAddress != this.addressAsString(this.address)) {
        this.manualAddress =  Object.assign({}, this.address);
        if (this.google) {
          this.geocodingInProgress = true;
          const rv = await this.geoCode(this.address);
          this.geocodingInProgress = false;
          if (rv.status && rv.status == 'hit') {
            this.geocodeResult = 'success';
            this.address.street = rv.location.streetName;
            this.address.streetnumber = rv.location.streetNumber == this.address.streetnumber ? rv.location.streetNumber : this.address.streetnumber;
            this.address.country = rv.location.countryCode;
            this.address.locality = rv.location.city;
            this.address.zip = rv.location.zipcode;
            this.address.lat = rv.location.latitude;
            this.address.long = rv.location.longitude;
            this.address.formatted_address = rv.location.formattedAddress;
            this.loadedAddress = this.addressAsString(this.address);
            this.showHint = true;
            this.exactHit = true;

            this.$emit('address-geocode', { address: this.address, status: 'success', hit: true })
          }
          else if (rv.status && rv.status == 'guess' && rv.location.latitude && rv.location.longitude) {
            this.geocodeResult = 'success';
            this.address.lat = rv.location.latitude;
            this.address.long = rv.location.longitude;
            this.address.formatted_address = rv.location.formattedAddress;
            this.loadedAddress = this.addressAsString(this.address);
            this.exactHit = false;
            this.fuzzyAddress = rv.location;
            this.showHint = true;
          }
          else {
            this.loadedAddress = this.addressAsString(this.address);
            this.address.lat = null;
            this.address.long = null;
            this.address.formatted_address = null;
            this.geocodeResult = 'error';
            this.showHint = true;
            this.$emit('address-geocode', { address: this.address, status: 'error'});
          }
        }
        else {
          this.address.lat = null;
          this.address.long = null;
          this.address.formatted_address = null;
          this.$emit('address-geocode', { address: this.address, status: 'no-google'});
        }
      }
    },
    async geoCode(args) {
      const geoPromise = new Promise((resolve, reject) => {
        this.googleGeocoder.geocode({
          address: args.street + " " + args.streetnumber,
          componentRestrictions: {
            country: args.country,
            postalCode: args.zip,
            locality: args.locality
          }
        }, (results, status) => {
          if (status !== "OK" || !results[0]) {
            reject(status);
          }
          resolve(results);
        });
      });
      let rv = geoPromise.then((results) => {
        for (var i = 0; i < results.length; i++) {
          let currentResult = results[i];
          if (currentResult.geometry.location_type == 'ROOFTOP') {
            return { status:'hit', location: extractAddrObj(currentResult) };
          }
        }
        if (results[0]) {
          return { status: 'guess', location: extractAddrObj(results[0]) }
        }
      }).catch ( (reason) => {
        if (reason === "ZERO_RESULTS") {
          return { status: "ERROR", description: "Location not Found", flag: "NO_LOC" };
        } else {
          throw new Error(reason);
        }
      });
      return rv;
    },
    addressAsString(address) {
      return [
        address.country,
        address.locality,
        address.zip,
        address.street,
        address.streetnumber,
        address.co_line].join(';')
    },
    niceAddress(address) {
      let nice = address.street + ' ' + address.streetnumber;
      if (address.co_line) {
        nice = nice + ', ' + address.co_line
      }
      nice = nice + ', ' + address.zip + ' ' + address.locality + ', ' + address.country;
      return nice;
    }
  }
}
</script>
